module.exports = __webpack_public_path__ + "img/40_37_026_390.020a299d.jpg";